import { useWizardStore } from '../store/wizardStore';
import { StepShell } from '../components/StepShell';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { MaskedInput } from '../components/ui/MaskedInput';
import { PassportFields } from '../components/form/PassportFields';
import { maskPhone } from '../utils/masks';
import { isValidClient, isPhone, isEmail } from '../utils/validators';
import type { ClientData } from '../types/wizard.types';

function getMissingFields(c: ClientData): string[] {
  const missing: string[] = [];
  if (c.fullName.trim().length < 3) missing.push('ФИО');
  if (c.passportSeries.replace(/\D/g, '').length !== 4) missing.push('Серия паспорта');
  if (c.passportNumber.replace(/\D/g, '').length !== 6) missing.push('Номер паспорта');
  if (c.passportIssuedBy.trim().length < 3) missing.push('Кем выдан');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(c.passportIssuedDate)) missing.push('Дата выдачи паспорта');
  if (c.registeredAddress.trim().length < 5) missing.push('Адрес регистрации');
  if (!isPhone(c.phone)) missing.push('Телефон');
  if (!isEmail(c.email)) missing.push('E-mail');
  return missing;
}

export function Step3_GreenForm() {
  const client = useWizardStore((s) => s.client);
  const set = useWizardStore((s) => s.setClientField);
  const goTo = useWizardStore((s) => s.goTo);
  const ok = isValidClient(client);
  const missing = ok ? [] : getMissingFields(client);

  return (
    <StepShell
      title="Данные клиента"
      subtitle="Заполните свои данные — они попадут во все договоры"
      current="green"
      footer={
        <div className="space-y-2">
          {missing.length > 0 && (
            <p className="text-xs text-amber-700 text-right">
              Не заполнено: {missing.join(' · ')}
            </p>
          )}
          <div className="flex justify-between">
            <Button variant="secondary" onClick={() => goTo('yellow')}>Назад</Button>
            <Button disabled={!ok} onClick={() => goTo('review')}>Далее — Ознакомление →</Button>
          </div>
        </div>
      }
    >
      <section className="section-green space-y-5">
        <Input
          label="ФИО полностью *"
          value={client.fullName}
          onChange={(e) => set('fullName', e.target.value)}
          placeholder="Иванов Иван Иванович"
        />
        <PassportFields client={client} update={set} />
        <Input
          label="Адрес регистрации *"
          value={client.registeredAddress}
          onChange={(e) => set('registeredAddress', e.target.value)}
        />
        <div className="grid md:grid-cols-2 gap-4">
          <MaskedInput
            label="Телефон *"
            value={client.phone}
            mask={maskPhone}
            onValueChange={(v) => set('phone', v)}
            inputMode="tel"
            placeholder="+7 (___) ___-__-__"
          />
          <MaskedInput
            label="Телефон (дополнительный)"
            value={client.phoneSecondary}
            mask={maskPhone}
            onValueChange={(v) => set('phoneSecondary', v)}
            inputMode="tel"
          />
          <Input
            label="E-mail *"
            type="email"
            value={client.email}
            onChange={(e) => set('email', e.target.value)}
            className="md:col-span-2"
            placeholder="client@example.com"
          />
        </div>
      </section>
    </StepShell>
  );
}
